const getCurrentWeekWithStartDateOnThursday = (getDateObject = false) => {
    let startDay = 4 //Thursday
    let date = Date.now();
    let d = new Date(date)
    let day = d.getDay()
    let diff = (day === startDay) ? 0 : (day < startDay) ? (7 - startDay + day ) : (day - startDay)


    d.setDate(d.getDate() - diff)

    d.setHours(0)
    d.setMinutes(0)
    d.setSeconds(0)
    d.setMilliseconds(0)

    return d
}

export default getCurrentWeekWithStartDateOnThursday